import { CalculationsProgressBanner } from "#batteries-included-components/Banners/CalculationsProgressBanner";
import { ImportDataActionStatusWithQueue } from "#batteries-included-components/Banners/ImportDataActionStatus";
import {
  CalculationsSummaryPanel,
  CalculationsTablePanel,
} from "#src/batteries-included-components";
import { getImportDataActionQueueKey } from "#src/batteries-included-components/Buttons/ImportDataAction/ImportDataAction.helpers";
import { CalculationsViewFilterArea } from "#src/batteries-included-components/FilterAreas/CalculationsFilterAreas";
import { useIsFeatureAvailable } from "#src/contexts/AuthenticatedContext.helpers";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { generateDocumentTitle } from "@validereinc/common-components";
import {
  AssetType,
  MeasurementTypeType,
  ResourceDefinitions,
} from "@validereinc/domain";
import React from "react";
import { Titled } from "react-titled";

const importDataActionQueueKey = getImportDataActionQueueKey({
  resource: {
    id: "estimation_method_config",
    description: "",
    label: {
      singular: "Volume Calculation",
      plural: "Volume Calculations",
    },
  },
});

export const CalculatorsVolumeTab = () => {
  const [isDataIngestionEnabled] = useIsFeatureAvailable({
    featureFlagQuery: "core:data_pipeline",
  });

  const [calcsAndRecordsSharedViewConfigStorageKey] = useStorageKey(
    ["view-configuration"],
    "calculations-records-shared"
  );
  const [
    volumeFilterConfigStorageKey,
    volumeTableConfigStorageKey,
    volumeTableStateStorageKey,
  ] = useStorageKey(
    ["filter-configuration", "table-configuration", "table-state"],
    ["calculations", "calculators", "list", "volume"]
  );
  const [volumeCalculationJobStorageKey] = useStorageKey(
    ["async-job"],
    "calculations-volumetric-bulk-calculate"
  );

  const measurementTypeFilter = ({ quantity }: MeasurementTypeType) =>
    quantity === "volume";

  return (
    <>
      <Titled
        title={generateDocumentTitle(
          `Volume ${ResourceDefinitions.calculator_result.label.plural}`
        )}
      >
        {isDataIngestionEnabled ? (
          <ImportDataActionStatusWithQueue
            queueKey={importDataActionQueueKey}
          />
        ) : null}
        <CalculationsProgressBanner
          jobStorageKey={volumeCalculationJobStorageKey}
        />
        <CalculationsViewFilterArea
          viewConfigStorageKey={calcsAndRecordsSharedViewConfigStorageKey}
          isPeriodDateRange
        />
        <CalculationsSummaryPanel
          assetType={AssetType.FLOW}
          defaultMeasurementTypes={["volume"]}
          measurementTypeFilter={measurementTypeFilter}
          filterConfigStorageKey={volumeFilterConfigStorageKey}
          viewConfigStorageKey={calcsAndRecordsSharedViewConfigStorageKey}
        />
        <CalculationsTablePanel
          assetType={AssetType.FLOW}
          defaultMeasurementTypes={["volume"]}
          measurementTypeFilter={measurementTypeFilter}
          calculationJobStorageKey={volumeCalculationJobStorageKey}
          filterConfigStorageKey={volumeFilterConfigStorageKey}
          tableConfigStorageKey={volumeTableConfigStorageKey}
          tableStateStorageKey={volumeTableStateStorageKey}
          viewConfigStorageKey={calcsAndRecordsSharedViewConfigStorageKey}
          showEstimationMethodStatusFilter
        />
      </Titled>
    </>
  );
};
